import { Col, Row } from 'antd';
import { isEmpty } from 'lodash';
import React, { useMemo, useState } from 'react';
import Select, { components } from 'react-select';

import { BasicButton } from '../../assets/common';
import { ar_down } from '../../assets/img';
import styles from './custom-filter-managing.module.scss';

const InputOption = ({ _Icon, getStyles, isFocused, isDisabled, children, innerProps, isSelected, ...rest }) => {
  const onMouseLeave = () => setIsActive(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const [isActive, setIsActive] = useState(false);

  // styles
  let bg = 'transparent';
  if (isFocused) bg = '#eee';
  if (isActive) bg = '#00a19c';

  const style = {
    backgroundColor: bg,
    alignItems: 'center',
    display: 'flex ',
    color: 'inherit',
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseUp,
    onMouseDown,
    style,
    onMouseLeave,
  };

  return (
    <components.Option {...rest} isFocused={isFocused} isDisabled={isDisabled} getStyles={getStyles} innerProps={props} isSelected={isSelected}>
      <Row gutter={4}>
        <Col>
          <input type="checkbox" className={styles.checkedFilter} checked={isSelected} onChange={(e) => e.preventDefault()} />
        </Col>
        <Col>{children}</Col>
      </Row>
    </components.Option>
  );
};

const CustomFilterManaging = (props) => {
  const { allOptions, placeholder, selectedOptions, setSelectedOptions, isDisabled, setIsApply, customMaxWidth, positionFilter } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [isChangedOption, setIsChangedOption] = useState(false);

  const defaultFilterOptions = useMemo(() => {
    return !isEmpty(positionFilter) ? positionFilter.filter((p) => p?.checked).map((i) => ({ value: i?.key, label: i?.key })) : [];
  }, [positionFilter]);

  const handleOnChange = (options, action, selectedOption) => {
    if (!Array.isArray(options)) return;

    const isSelect = action === 'select-option';
    const isDeselect = action === 'deselect-option';
    const isSelectAll = action === 'select-option' && selectedOption.value === 'All';
    const isDeSelectAll = action === 'deselect-option' && selectedOption.value === 'All';
    const isSelectNone = action === 'select-option' && selectedOption.value === 'None';
    const isDeSelectNone = action === 'deselect-option' && selectedOption.value === 'None';
    const numOptionsWithoutNoneOption = allOptions.length - 1;
    const numOptionsWithoutAllOption = allOptions.length - 2;

    if (!isSelectAll && !isSelectNone && !isDeSelectAll && !isDeSelectNone) {
      if (isSelect && options.length === numOptionsWithoutNoneOption) {
        setSelectedOptions(allOptions.filter((item) => item.value !== 'None' && item.value !== 'All'));
        return;
      }
      if (isSelect && options.length === numOptionsWithoutAllOption) {
        setSelectedOptions(allOptions.filter((item) => item.value !== 'None'));
        return;
      }
      if (isSelect && options.length == 2 && options.map((op) => op.value).includes('None')) {
        setSelectedOptions(allOptions.filter((item) => item.value === selectedOption.value));
        return;
      }
      if (isDeselect && options.length === numOptionsWithoutAllOption) {
        setSelectedOptions(options.filter((item) => item.value !== 'All'));
        return;
      }
      setSelectedOptions(options);
      return;
    }

    if (isDeSelectAll || isDeSelectNone) {
      setSelectedOptions([]);
      return;
    }
    if (isSelectAll) {
      setSelectedOptions(allOptions.filter((item) => item.value !== 'None'));
    }
    if (isSelectNone) {
      setSelectedOptions(allOptions.filter((item) => item.value === 'None'));
    }
  };

  const CustomMenu = ({ innerRef, innerProps, isDisabled, children }) => {
    return !isDisabled ? (
      <div ref={innerRef} {...innerProps} className={`custom-react-select-menu-list has-apply-btn`}>
        <div className={styles.customTitle}>Show</div>
        {children}
        <div className={`${styles.wrapperButton} custom-react-select-apply-btn`}>
          <BasicButton onClick={() => handleClickClearBtn()} style={{ minWidth: '105px' }}>
            Clear
          </BasicButton>
          <BasicButton mode="teal" onClick={() => handleClickApplyBtn()} style={{ minWidth: '105px' }}>
            Apply
          </BasicButton>
        </div>
      </div>
    ) : null;
  };

  const handleClickClearBtn = () => {
    setSelectedOptions([]);
    setIsApply(true);
    setIsOpen(false);
  };

  const handleClickApplyBtn = () => {
    setIsOpen(false);
    setIsApply(true);
  };

  return (
    <Select
      menuIsOpen={isOpen}
      defaultMenuIsOpen={false}
      autoFocus={false}
      value={selectedOptions && isChangedOption ? selectedOptions : defaultFilterOptions}
      placeholder={placeholder}
      isMulti
      isClearable={false}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      controlShouldRenderValue={false}
      onChange={(options, { action, option }) => {
        handleOnChange(options, action, option);
        setIsChangedOption(true);
      }}
      options={allOptions}
      components={{
        Option: InputOption,
        IndicatorSeparator: null,
        DropdownIndicator: (props) => (
          <components.DropdownIndicator {...props}>
            <img src={ar_down} alt="drop_down" />
          </components.DropdownIndicator>
        ),
        MenuList: CustomMenu,
      }}
      onMenuOpen={() => {
        setIsOpen(true);
        setIsChangedOption(false);
      }}
      onMenuClose={() => setIsOpen(false)}
      classNamePrefix={'custom-react-select'}
      className={
        !isEmpty(selectedOptions) ? 'custom-react-select custom-react-select__type-1 active' : 'custom-react-select custom-react-select__type-1'
      }
      styles={{
        control: (base) => ({
          ...base,
          cursor: 'pointer',
          margin: 0,
          height: 40,
          minWidth: 186,
          border: '1px solid #D3DEE8',
          boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
          borderRadius: 4,
          '&:hover': {
            border: '1px solid #D3DEE8',
            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
          },
        }),
        option: (provided) => ({
          ...provided,
          padding: 10,
          fontSize: '12px',
          backgroundColor: 'white',
          '&:active': {
            backgroundColor: 'white',
          },
          '&:hover': {
            backgroundColor: 'white',
          },
        }),
        placeholder: (provided) => ({
          ...provided,
          color: '#8D8D8D',
          fontSize: 14,
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          paddingRight: 20,
        }),
        menu: (provided) => ({
          ...provided,
          minWidth: '234px',
          maxWidth: customMaxWidth ? `${customMaxWidth}px` : 'auto',
        }),
      }}
      isDisabled={isDisabled}
    />
  );
};

export default CustomFilterManaging;
